var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { combineReducers } from "redux";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import UserAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import routeUpdateReducer from "@ane/core/lib/services/syncUrlAndStore/RouteUpdateReducer";
import { ExperimentSearchReducer } from "./views/component/ExperimentSearch/ExperimentSearchReducer.js";
import { FlightSearchReducer } from "./views/component/FlightSearch/reducers/FlightSearchReducer.js";
import { MyActivitiesReducer } from "./views/component/MyActivities/MyActivitiesReducer.js";
import { SearchLogPerformanceReducer } from "./views/Common/logging/SearchLogPerformanceReducers.js";
import GlobalConfigReducer from "@ane/exp-data/lib/globalConfig/GlobalConfigReducer";
import "./views/component/FeatureSearchV4/search-context/index.js";
import { authoringApi, vnextAnalysisApi, expFeatureReadV2Api, xCardApi } from "@ane/exp-data/lib/redux/rtkquery";
import { subscriberDisplayNamesByEntitiesReducer } from "./views/component/FeatureSearchV4/subscribers/duck.js";
import { ExperimentDetailsReducer } from "./views/component/FeatureSearchV4/feature-detail/ExperimentDetailsReducer.js";
import { FeatureDetailsReducer } from "./views/component/FeatureSearchV4/feature-detail/FeatureDetailsReducer.js";
import { ActiveProgressionsExpandListPropsReducer } from "./views/component/FeatureSearchV4/active-progressions/ActiveProgressionsListPropsReducer.js";
import { rootReducer } from "./views/component/FeatureSearchV4/search-context/reducers.js";
const moduleReducer = __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues({
  globalConfig: GlobalConfigReducer
}, routeUpdateReducer), currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject), {
  experimentSearchModule: combineReducers({
    featureSearchV4: rootReducer,
    experimentSearch: ExperimentSearchReducer,
    myActivities: MyActivitiesReducer,
    flightSearch: FlightSearchReducer,
    searchLogPerformance: SearchLogPerformanceReducer,
    subscribersDisplayNames: subscriberDisplayNamesByEntitiesReducer,
    experimentDetails: ExperimentDetailsReducer,
    featureDetails: FeatureDetailsReducer,
    activeProgressionsListProps: ActiveProgressionsExpandListPropsReducer
  }),
  [authoringApi.reducerPath]: authoringApi.reducer,
  [vnextAnalysisApi.reducerPath]: vnextAnalysisApi.reducer,
  [expFeatureReadV2Api.reducerPath]: expFeatureReadV2Api.reducer,
  [xCardApi.reducerPath]: xCardApi.reducer
});
export {
  moduleReducer as default,
  moduleReducer
};
//# sourceMappingURL=reducers.js.map
